<template>
  <div id="app">
    <map-drawer :id="id" v-if="id" />
  </div>
</template>

<script>
import mapDrawer from './components/mapDrawer.vue';

export default {
  name: 'app',
  components: {
    mapDrawer,
  },
  data() {
    return {
      id: null,
    };
  },
  methods: {
    getParameterByName(name, url) {
      if (!url) {
        url = window.location.href;
      }
      // eslint-disable-next-line
      name = name.replace(/[\[\]]/g, "\\$&");
      const regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
        results = regex.exec(url);
      if (!results) {
        return null;
      }
      if (!results[2]) {
        return "";
      }
      return decodeURIComponent(results[2].replace(/\+/g, " "));
    },
  },
  mounted() {
    this.id = this.getParameterByName("id");
  },
}
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
</style>
